import { ICONS_LIB, ICONS_VERSION } from './icons.spec.js'
export { availableIcons } from './availableIcons.spec.js'

const URI_SYMBOLS = /[\r\n%#()<>?[\\\]^`{|}]/g

export function flushCacheIcons() {
  Object.keys(localStorage).forEach(item => {
    if (item.startsWith('icons-pkg')) {
      localStorage.removeItem(item)
    }
  })
}

export function invalidateCacheByVersionCheck() {
  if (localStorage.getItem('icons-lib-ver') !== ICONS_VERSION) {
    flushCacheIcons()
    localStorage.setItem('icons-lib-ver', ICONS_VERSION)
  }
}

export async function fetchPack(packName) {
  invalidateCacheByVersionCheck()
  const icon = localStorage.getItem(`icons-pkg-${packName}`)
  if (icon) {
    return Promise.resolve(JSON.parse(icon))
  }

  return fetch(`/assets/icons/${packName}.json`)
    .then(r => {
      if (r.status !== 200) {
        throw new Error(`Icon Lib: Failed to fetch pack ${packName} with status ${r.status}.`)
      }
      return r
    })
    .then(r => r.json())
    .then(pkg => {
      localStorage.setItem(`icons-pkg-${packName}`, JSON.stringify(pkg))
      return pkg
    })
}

export function svgToImgData(svgNodes) {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E${svgNodes.replace(URI_SYMBOLS, encodeURIComponent)}%3C/svg%3E`
}

export async function fetchIcon(collection, name) {
  if (!collection || !name) {
    throw new Error('Icon Lib: please provide both collection and name to fetch right icon.')
  }
  // @ts-ignore
  const iconSpec = ICONS_LIB[`${collection}:${name}`]
  if (!iconSpec) {
    throw new Error(`Icon Lib: Not found icon: ${name} from collection ${collection}.`)
  }

  return fetchPack(`${collection}.${iconSpec[0]}.${ICONS_VERSION}`).then(pkg => pkg[iconSpec[1]])
}
